import { useAtsProjectsApi } from '@/composables/useApi';
import { HttpStatus } from '@/core/shared/errors/enums/http-status.enum';
import { InternalError } from '@/core/shared/errors/internal.error';
import type { JobCustomMachine } from '@factoryfixinc/ats-interfaces';

export class CustomMachinePersistence {
  public async getProjectCustomMachines(
    employerId: number,
    projectId: number,
  ): Promise<JobCustomMachine[]> {
    const url = `/project/${projectId}/employer/${employerId}/custom-machine`;
    const { data, error, statusCode } = await useAtsProjectsApi(url)
      .get()
      .json<JobCustomMachine[]>();

    if (statusCode.value === HttpStatus.NOT_FOUND || statusCode.value === HttpStatus.FORBIDDEN) {
      return [];
    }

    if (error.value) {
      throw new InternalError('Could not get project custom machines', {
        error: error.value,
        status: statusCode.value,
        data: { employerId, projectId },
      });
    }

    return data.value ?? [];
  }

  public async replaceProjectCustomMachines(
    employerId: number,
    projectId: number,
    customMachines: JobCustomMachine[],
  ): Promise<JobCustomMachine[]> {
    const url = `/project/${projectId}/employer/${employerId}/custom-machine`;
    const { data, error, statusCode } = await useAtsProjectsApi(url)
      .put(JSON.stringify(customMachines))
      .json<JobCustomMachine[]>();

    if (error.value) {
      throw new InternalError('Could not replace project custom machines', {
        error: error.value,
        status: statusCode.value,
        data: { employerId, projectId, customMachines },
      });
    }

    return data.value ?? [];
  }
}
